class MarketData {
  constructor(indexDaily, fundDaily) {
    this.buildData(indexDaily, fundDaily);
  }

  /**
   * Build the pricesMap and returnMap from indexDaily and fundDaily data
   * @param {Array} indexDaily 
   * @param {Array} fundDaily 
   */
  buildData(indexDaily, fundDaily) {
    // Create a map by date with the indexes and funds prices
    this.pricesMap = {};

    // Create a map by date with the indexes and funds returns
    this.returnsMap = {};

    // Get all the dates from indexDaily and fundDaily arrays
    // to be the keys of the maps
    const indexDailyDates = indexDaily.map((i) => i.referenceDate);
    const fundDailyDates = fundDaily.map((f) => f.referenceDate);
    const dates = [...new Set([...indexDailyDates, ...fundDailyDates])];
    dates.sort();

    // Get all funds and index symbols
    const indexSymbols = indexDaily.map((i) => i.indexName);
    const fundSymbols = fundDaily.map((f) => f.fundName);
    const symbols = [...new Set([...fundSymbols, ...indexSymbols])];

    let prevPrices = undefined;

    // Populate pricesMap and returnMap
    for (let i = 0; i < dates.length; i++) {
      const currentDate = dates[i];
      const currentPrices = {};
      const currentReturns = {};

      // Add fund daily data to prices
      fundDaily
        .filter((e) => e.referenceDate === currentDate)
        .forEach((f) => {
          currentPrices[f.fundName] = f.quota;
        });

      // Add index daily data to prices
      indexDaily
        .filter((e) => e.referenceDate === currentDate)
        .forEach((f) => {
          currentPrices[f.indexName] = f.value;
        });

      if (prevPrices) {
        // eslint-disable-next-line no-loop-func
        symbols.forEach((symbol) => {
          // Verify if there is value for each element. If not, forward fill
          // prices.
          currentPrices[symbol] = currentPrices[symbol] || prevPrices[symbol];

          // Calculate returns
          currentReturns[symbol] =
            prevPrices[symbol] && prevPrices[symbol] !== 0.0
              ? currentPrices[symbol] / prevPrices[symbol] - 1
              : 0.0;
        });
      }

      // Add to map
      this.pricesMap[currentDate] = currentPrices;
      this.returnsMap[currentDate] = currentReturns;

      // Set new prevPrices to currentPrices
      prevPrices = currentPrices;
    }
  }
}

export default MarketData;
